import { create } from 'zustand';
import api, { BACKEND_URL } from '../lib/api';

const useSettingsStore = create((set, get) => ({
  settings: null,
  siteContent: null,
  loading: true,
  feedbackOpen: false,

  setFeedbackOpen: (open) => set({ feedbackOpen: open }),

  fetchSettings: async () => {
    try {
      const [settingsRes, contentRes] = await Promise.all([
        api.get('/settings'),
        api.get('/content')
      ]);
      const settings = settingsRes.data;
      const content = contentRes.data;

      // Apply design system CSS variables
      if (settings.design_system) {
        const root = document.documentElement;
        Object.entries(settings.design_system).forEach(([key, value]) => {
          root.style.setProperty(key, value);
        });
      }

      // Apply title
      if (settings.site_title) {
        document.title = settings.site_title;
      }

      // Apply favicon — local fallback
      if (settings.favicon_url) {
        const faviconUrl = settings.favicon_url.startsWith('http')
          ? settings.favicon_url
          : settings.favicon_url.startsWith('/api/')
            ? `${BACKEND_URL}${settings.favicon_url}`
            : settings.favicon_url;
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = `${faviconUrl}?v=${Date.now()}`;
      }

      set({ settings, siteContent: content, loading: false });
    } catch (error) {
      console.error('Failed to fetch settings:', error);
      set({ loading: false });
    }
  },

  updateSettings: (newSettings) => {
    set({ settings: { ...get().settings, ...newSettings } });
    // Re-apply design system
    if (newSettings.design_system) {
      const root = document.documentElement;
      Object.entries(newSettings.design_system).forEach(([key, value]) => {
        root.style.setProperty(key, value);
      });
    }
    if (newSettings.site_title) {
      document.title = newSettings.site_title;
    }
  },

  updateContent: (newContent) => {
    set({ siteContent: { ...get().siteContent, ...newContent } });
  },

  getImageUrl: (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    // Paths starting with /api/ are backend-served (user uploads)
    if (path.startsWith('/api/')) return `${BACKEND_URL}${path}`;
    // Paths starting with / are local public assets
    if (path.startsWith('/')) return path;
    return `${BACKEND_URL}${path}`;
  }
}));

export default useSettingsStore;
